import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps, Box } from '@mui/material';
import { PropsWithChildren, useCallback, useState, ReactElement } from 'react';

type TooltipProps = MuiTooltipProps;

// In MUI v5, the cursor will be passed to <Box> via its sx={} prop
// https://next.material-ui.com/system/basics/
const WithTooltip = (props: PropsWithChildren<TooltipProps>): ReactElement => {
  const [open, setOpen] = useState(false);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleOpen = useCallback(() => setOpen(true), []);
  const toggleTooltip = useCallback(() => setOpen((prev) => !prev), []);
  return (
    <Box style={{ cursor: 'help' }}>
      <MuiTooltip
        title={props.title}
        arrow
        placement={props.placement}
        open={open}
        onClose={handleClose}
        onClick={toggleTooltip}
        onTouchStart={toggleTooltip}
        onOpen={handleOpen}
        leaveTouchDelay={props.leaveTouchDelay}
        sx={{
          py: 1,
          px: 1.5,
        }}
      >
        {props.children}
      </MuiTooltip>
    </Box>
  );
};

export { WithTooltip };
